"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
示例， （注：step不是真实代码处理时的step）
Battle step=3 回合处理阶段
    Turn step=4 技能处理阶段
        Skill step=2 攻击处理阶段
            Attack step = 5 结算阶段
                UpdateHp step = 1  生命处理
            Buff buff附加
 */
